import React from 'react';
import { graphql, useFragment } from 'react-relay';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import type { featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$key } from '@atlassian/jira-relay/src/__generated__/featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal.graphql';
import type { OnInstallSuccess } from '@atlassian/jira-software-empty-state-experience-feature-flags/src/common/types.tsx';
import { FeatureFlagEmptyStateExperienceEntryPoint } from '@atlassian/jira-software-empty-state-experience-feature-flags/src/ui/async';

export const FeatureFlagEmptyStateExperienceModal = ({
	isOpen,
	onClose,
	devOpsFeatureFlagProviders,
	onInstallSuccess,
}: {
	isOpen: boolean;
	onClose: () => void;
	devOpsFeatureFlagProviders: featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$key;
	onInstallSuccess: OnInstallSuccess;
}) => {
	const featureFlagProviders = useFragment(
		graphql`
			fragment featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal on DevOpsFeatureFlagProvider
			@relay(plural: true) {
				...async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint
			}
		`,
		devOpsFeatureFlagProviders,
	);

	const entryPoint = (
		<FeatureFlagEmptyStateExperienceEntryPoint
			onInstallSuccess={onInstallSuccess}
			devOpsFeatureFlagProviders={featureFlagProviders}
			isOpen={isOpen}
			onClose={onClose}
		/>
	);

	return (
		<ModalTransition>
			{isOpen ? (
				<ShortcutScope>
					<ModalDialog onClose={onClose} width={592} autoFocus={false}>
						{entryPoint}
					</ModalDialog>
				</ShortcutScope>
			) : null}
		</ModalTransition>
	);
};
